{
  "menu": {
    "header": "Databases",
    "items": {
      "databases": "Databases",
      "clientes": "Clients",
      "views": "Views",
      "media": "Media and Files",
      "users": "Users",
      "agents": "Agents",
      "mail": "Mail",
      "recording": "Recording Videos",
      "triggers": "Triggers",
      "knowledge": "Knowledge Graph",
      "tags": "Semantic Tags",
      "payments": "Payment Links"
    }
  },
  "registry": {
    "breadcrumb": {
      "views": "databases > views",
      "media": "databases > media",
      "triggers": "databases > triggers",
      "graph": "databases > graph",
      "tags": "semantic",
      "general": "databases > general"
    },
    "columns": {
      "name": "Name",
      "idData": "Data ID",
      "rowCount": "Rows",
      "views": "Views",
      "createdAt": "Created"
    },
    "openTable": "Open table",
    "noName": "(No Name)"
  },
  "viewPage": {
    "loading": "Loading table...",
    "noViews": "This table has no available view.",
    "backButton": "Back to Databases"
  },
  "table": {
    "loading": "Loading data...",
    "error": {
      "notFoundTitle": "Table or View not found",
      "genericTitle": "Error loading table",
      "notFoundDetail": "This view may have been deleted."
    },
    "search": {
      "placeholder": "Search...",
      "aria": "Search in table"
    },
    "untitledView": "Untitled",
    "viewNameLoading": "Loading...",
    "tableFallbackName": "Table",
    "view": {
      "copyFullIdTitle": "Click to copy full ID",
      "copyFullIdAria": "Copy full view ID",
      "copyIdTitle": "Click to copy ID",
      "copyIdAria": "Copy view ID",
      "configure": "Configure View",
      "delete": "Delete View",
      "noOtherViews": "No other views",
      "deleteConfirm": "Are you sure you want to delete the view \"{{name}}\"? The underlying data table will not be deleted.",
      "deletedInfo": "View deleted. No other views remain visible.",
      "deleteError": "Error deleting view: {{error}}",
      "deleteNetworkError": "Connection error while deleting view"
    },
    "flowToggle": {
      "on": "Back to Table",
      "off": "View as Board / Flow"
    },
    "row": {
      "deleteTitle": "Delete row",
      "deleteConfirm": "Delete this row permanently?",
      "deleteError": "Error deleting row",
      "addRow": "New row",
      "addRowError": "Error adding row: {{error}}"
    },
    "column": {
      "createError": "Error creating column: {{error}}",
      "createNetworkError": "Network error creating column"
    },
    "pagination": {
      "prev": "Previous",
      "next": "Next",
      "pageInfo": "Page {{current}} of {{total}}",
      "items": "{{count}} items"
    },
    "noRowsFound": "No rows found",
    "noColumnsFound": "No columns found"
  },
  "flow": {
    "addText": "Add Text",
    "addLine": "Add Line",
    "cancel": "Cancel",
    "showAllRows": "Show all rows",
    "hidePlacedRows": "Hide already placed rows",
    "searchRows": {
      "placeholder": "Search rows to drag...",
      "aria": "Search rows to drag onto the Board"
    },
    "selectColumn": {
      "placeholder": "Select column...",
      "aria": "Search and select a Board column"
    },
    "textNodePlaceholder": "Write text...",
    "textNodeAria": "Text node",
    "increaseLineWidth": "Increase line thickness",
    "decreaseLineWidth": "Decrease line thickness",
    "deleteLine": "Delete line",
    "increaseFontSize": "Increase font size",
    "decreaseFontSize": "Decrease font size",
    "deleteTextNode": "Delete text node",
    "deleteConnection": "Delete connection",
    "assignedTo": "Assigned to: {{name}}",
    "unknownUser": "User",
    "statusAria": "Status: {{label}}"
  },
  "cells": {
    "persona": {
      "selectPlaceholder": "Select person...",
      "searchPlaceholder": "Search people...",
      "noUsersFound": "No users found"
    },
    "fecha": {
      "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      "dayLetters": ["S", "M", "T", "W", "T", "F", "S"],
      "placeholder": "Date",
      "assignPersonPlaceholder": "Assign person...",
      "copyIdTitle": "Click to copy ID",
      "durationConfiguredTitle": "Duration set from calendar",
      "defaultEventTitle": "Event",
      "eventDescription": "Assigned to: {{name}}. Date: {{date}}",
      "status": {
        "completed": "{{count}} days (Completed)",
        "elapsed_one": "{{count}} day elapsed",
        "elapsed_other": "{{count}} days elapsed",
        "daysLeft_one": "1 day left",
        "daysLeft_other": "{{count}} days left",
        "daysLate_one": "1 day late",
        "daysLate_other": "{{count}} days late"
      },
      "networkError": "Network error",
      "saveError": "Error saving date"
    },
    "texto": {
      "placeholder": "Empty",
      "goToPage": "Go to page",
      "copyLinkIdTitle": "Copy link ID"
    },
    "tag": {
      "addPlaceholder": "Add tag...",
      "createOption": "Create \"{{value}}\""
    },
    "numero": {
      "minutesPlaceholder": "Minutes e.g. 45",
      "errorSavingTitle": "Error saving"
    },
    "filesAndMedia": {
      "addFileTitle": "Add file",
      "dropHint": "Click or drop files here",
      "dropSubtext": "Supports images, pdf, docs",
      "uploadError": "Error uploading {{fileName}}"
    },
    "descripcion": {
      "placeholder": "Add description (390 chars)..."
    },
    "menuDesplegable": {
      "placeholder": "Select...",
      "searchOrCreatePlaceholder": "Search or Create...",
      "deleteOptionTitle": "Delete option",
      "createOption": "Create \"{{value}}\"",
      "typeToSearch": "Type to search or create"
    }
  }
}
